import { FormTable, FormTableHeader } from 'stories/components'
import { capitalize } from 'utils'

export type ReferenceKey = 'subcontractor' | 'supplier' | 'client'

type ContractorReferencesProps = {
  referenceKey: ReferenceKey
  status: Record<string, boolean>
  canEdit: boolean
  inputs: Record<string, any>
  defaultData: any[]
  onSubmitReferences: (id: any, values: Record<string, any>, key: string) => Record<string, any>
  onRemoveReferences: (id: any, key: string) => void
  showHistory: (key: string, headers?: Array<FormTableHeader>) => void
}

export function ContractorReferences({
  referenceKey,
  status,
  canEdit,
  inputs,
  defaultData,
  onSubmitReferences,
  onRemoveReferences,
  showHistory,
}: ContractorReferencesProps) {
  const key = referenceKey
  return (
    <div key={key}>
      <FormTable
        key={`references-${key}`}
        header={[
          { key: 'name', title: `${capitalize(key)} Name` },
          { key: 'email', title: 'Email' },
          { key: 'phone', title: 'Telephone' },
          { key: 'scope', title: 'Scope of Work Completed' },
        ]}
        permission={canEdit ? 1 : 3}
        inputs={inputs}
        defaultData={defaultData}
        onSubmit={(id, values) => onSubmitReferences(id, values, key)}
        onRemove={(id) => onRemoveReferences(id, key)}
        showHistory={(headers) => showHistory(key, headers)}
      />
      {!status[key] && (
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-[16px] my-4"
          role="alert"
        >
          At least 3 references are required!
        </div>
      )}
    </div>
  )
}
